import React, { useRef, useState, useEffect } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import $ from "jquery";
import { minDate } from "../../Constants/Constants";

const UpdateMaterialIncoming = ({
  selectedRowsData,
  updateHandleChange,
  getData,
  setselectedRowsData,
}) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const companyName = selectedRowsData.company?.company_name || "";
  const companyLocation = selectedRowsData.company?.location || "";
  const companyId = selectedRowsData.company?.id || "";
  const materialId = selectedRowsData?.materialName?.id || "";
  const materialName = selectedRowsData?.materialName?.material_name || "";
  const incoming_details = selectedRowsData?.incoming_details || [];
  const [incomingList, setIncomingList] = useState([]);
  const [partyName, setPartyName] = useState([]);

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  function handleReset() {
    setselectedRowsData([]);
    setPartyName([]);
  }

  useEffect(() => {
    if (selectedRowsData) {
      const list = incoming_details?.map((item) => ({
        party_name_id: item.party_name_id,
        party_name: item.party_name,
        incoming: item.incoming,
      }));
      setIncomingList(list);
    }
  }, [selectedRowsData]);

  const handleAddFields = () => {
    setIncomingList([...incomingList, { party_name: "", incoming: "" }]);
  };

  const handleChangeInput = (index, event) => {
    const { name, value } = event.target;
    const updatedList = [...incomingList];
    updatedList[index] = { ...updatedList[index], [name]: value };
    setIncomingList(updatedList);
  };
  const handleClose = (index) => {
    const values = [...incomingList];
    values.splice(index, 1);
    setIncomingList(values);
  };
  const getSinglePartyName = async (e) => {
    let BASE_URL = SERVER_URL + `/api/party/drop-partyName/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: companyId,
        material_name_id: materialId,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setPartyName(response.data);
    } else {
      toast.error(response.message);
    }
  };

  useEffect(() => {
    if (materialId && companyId) {
      getSinglePartyName();
    }
  }, [materialId]);
  const updateData = async (e) => {
    e.preventDefault();
    const { id, material_name_id, date } = selectedRowsData;
    const BASE_URL = `${SERVER_URL}/api/mat-incoming/material-incoming/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        material_name_id,
        company_id: companyId,
        incoming_details: incomingList,
        date,
      }),
    });
    const response = await res.json();
    if (res.ok) {
      closeModal();
      toast.success(response.message);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="editModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Material Incoming
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={handleReset}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form className="form-sample" onSubmit={updateData}>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Company_Name">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="company_name"
                              id="Company_Name"
                              placeholder="Company Name"
                              readOnly
                              value={`${companyName}, ${companyLocation}`}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Material_Name">Material Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="material_name"
                              id="Material_Name"
                              placeholder="Material Name"
                              onChange={updateHandleChange}
                              value={materialName}
                              readOnly
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Date">Date</label>
                            <input
                              type="text"
                              className="form-control"
                              name="material_name"
                              id="Date"
                              placeholder="Date"
                              onChange={updateHandleChange}
                              value={selectedRowsData.date}
                              readOnly
                              required
                              min={minDate}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>

                      {incomingList &&
                        incomingList?.length > 0 &&
                        incomingList?.map((item, index) => (
                          <React.Fragment key={index}>
                            <div className="row" key={index}>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="partyName">Party Name</label>
                                  {/* <input
                                  type="text"
                                  className="form-control"
                                  name="party_name"
                                  id="partyName"
                                  placeholder="Party name"
                                  onChange={(event) =>
                                    handleChangeInput(index, event)
                                  }
                                  value={item.party_name}
                                  readOnly
                                /> */}
                                  <select
                                    className="form-control form-control-lg"
                                    onChange={(event) =>
                                      handleChangeInput(index, event)
                                    }
                                    name="party_name_id"
                                    value={item.party_name_id}
                                    id="partyName"
                                    required
                                    autoComplete="off"
                                  >
                                    <option value="">Select</option>
                                    {partyName &&
                                      partyName?.length > 0 &&
                                      partyName.map((item, index) => (
                                        <option
                                          value={`${item.id}`}
                                          key={index}
                                        >{`${item.party_name}`}</option>
                                      ))}
                                  </select>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="Incoming">Incoming</label>
                                  <div className="input-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="incoming"
                                      id="Incoming"
                                      placeholder="Incoming"
                                      onChange={(event) =>
                                        handleChangeInput(index, event)
                                      }
                                      value={item.incoming}
                                      required
                                      autoComplete="off"
                                    />

                                    <span className="input-group-append ml-2">
                                      <div className="col-md-2">
                                        <button
                                          type="button"
                                          title="Remove"
                                          disabled={incomingList?.length <= 1}
                                          className="btn btn-outline-danger btn-rounded btn-icon"
                                          onClick={() => handleClose(index)}
                                        >
                                          <span className="mdi mdi-close-thick"></span>
                                        </button>
                                      </div>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </React.Fragment>
                        ))}
                      <span className="input-group-append ml-2">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleAddFields}
                        >
                          Add More
                        </button>
                      </span>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={updateData}
                      >
                        Update
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateMaterialIncoming;
